exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PresentationItems .actions{display:flex;justify-content:flex-end;margin-bottom:20px}.PresentationItems .actions .add-present{width:40px;height:40px;border-radius:50px;background:#00adff;display:flex;align-items:center;justify-content:center;color:#fff;font-size:20px}.PresentationItems .question-types-block{display:flex;flex-direction:column}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Sliders/components/PresentationItems/style.scss
// module id = 5271
// module chunks = 0